import { Container } from './styles'

interface SummaryProps {
    brute: number,
    cost: number,
    liquid: number
}

export function Summary({ brute, cost, liquid }: SummaryProps) {


    return (
        <Container>
            <div>
                <header>
                    <p>Receita Bruta</p>
                </header>
                <strong>{new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(brute)}</strong>
            </div>
            <div>
                <header>
                    <p>Total de gastos</p>
                </header>
                <strong>{new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(cost)}</strong>
            </div>
            <div className="highlight-background">
                <header>
                    <p>Receita Líquida</p>
                </header>
                <strong>{new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(liquid)}</strong>
            </div>
        </Container>
    )
}